import React, { useEffect, useMemo, useState } from 'react'
import { debounce } from 'lodash'
import { Link } from "react-router-dom"
import { Col, Input, Row } from 'reactstrap'
import AdvancedFiltersControl from '../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'
import { ROUTES } from '../Layout/routes'

const FILTER_ENTITIES = {
    'automations': 'automation',
    'execution-logs': 'automation_execution_log',
}

const AutomatelyListHeader = ({ activeTab, searchTerm = '', setSearchTerm, showSearch = true, showCreateAction = true }) => {
    const [searchInput, setSearchInput] = useState(searchTerm)
    const isExecutionLogsView = activeTab === 'execution-logs'
    const filterEntity = FILTER_ENTITIES[activeTab]
    const searchPlaceholder = isExecutionLogsView ? 'Search execution logs' : 'Search automations'
    const updateSearchFilter = useMemo(() => debounce((value) => {
        setSearchTerm?.(value)
    }, 400), [setSearchTerm])

    useEffect(() => {
        return () => updateSearchFilter.cancel()
    }, [updateSearchFilter])

    useEffect(() => {
        setSearchInput(searchTerm)
    }, [activeTab, searchTerm])

    const handleSearchChange = (event) => {
        const { value } = event.target
        setSearchInput(value)
        updateSearchFilter(value)
    }

    return (
        <header className="automately-list-header">
            <Row className="automately-list-toolbar pb-2">
                <Col xs="12" md="6" className="automately-search-column">
                    <div className="automately-search-filter-group">
                        {showSearch && <label className="automately-search">
                            <Input
                                type="search"
                                name="searchTerm"
                                placeholder={searchPlaceholder}
                                aria-label={searchPlaceholder}
                                onChange={handleSearchChange}
                                value={searchInput}
                            />
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </label>}
                        {/* key={filterEntity} remounts the control on tab switch so its
                            internal isOpen resets to closed for the new entity -- the
                            control has no entity-change effect of its own to do this. */}
                        <AdvancedFiltersControl key={filterEntity} entity={filterEntity} />
                    </div>
                </Col>

                <Col xs="12" md="6" className="automately-list-actions">
                    {showCreateAction && (
                        <Link to={`${ROUTES.automations.path}new`}>
                            New Automation <i className="fa fa-plus-square" aria-hidden="true"></i>
                        </Link>
                    )}
                </Col>
            </Row>
            <Row>
                <Col xs="12" className="search-filter-container mb-2">
                    <AppliedAdvancedFilters entity={filterEntity} context={null} />
                </Col>
            </Row>
        </header>
    )
}

export default AutomatelyListHeader
